export const GET_PROVIDERS = 'GET_PROVIDERS';
export const GET_PROVIDERS_SUCCESS = 'GET_PROVIDERS_SUCCESS';
export const GET_PROVIDERS_ERROR = 'GET_PROVIDERS_ERROR';

export const POST_PROVIDER = 'POST_PROVIDER';
export const POST_PROVIDER_SUCCESS = 'POST_PROVIDER_SUCCESS';
export const POST_PROVIDER_ERROR = 'POST_PROVIDER_ERROR';
